import React from 'react';
export default (
  <svg width="20px" height="17px" viewBox="0 0 20 17">
    <path
      d="M727.375,30.5325 L727.375,32.99125 C727.375,33.63 727.725,34.225 728.285,34.53125 L732.66,36.92 C733.185,37.20875 733.815,37.20875 734.34,36.92 L738.715,34.53125 C739.275,34.225 739.625,33.63 739.625,32.99125 L739.625,30.5325 L734.34,33.42 C733.815,33.70875 733.185,33.70875 732.66,33.42 L727.375,30.5325 Z M732.66,22.08 L725.28375,26.105 C724.68,26.4375 724.68,27.3125 725.28375,27.645 L732.66,31.67 C733.185,31.95875 733.815,31.95875 734.34,31.67 L741.375,27.82875 L741.375,33 C741.375,33.48125 741.76875,33.875 742.25,33.875 C742.73125,33.875 743.125,33.48125 743.125,33 L743.125,27.39125 C743.125,27.0675 742.95,26.77875 742.67,26.62125 L734.34,22.08 C733.815,21.8 733.185,21.8 732.66,22.08 Z"
      transform="translate(-724 -21)"
      fill="#4024d3"
      fillRule="nonzero"
    />
  </svg>
);
